document.addEventListener('DOMContentLoaded', function() {

    const btnSeleccionarCompProducto = document.querySelectorAll('.btnSeleccionarCompProducto');
    const modalOrigen = document.querySelector('#modalCrearTurnoInyeccion');
    const modalComposicionProducto = document.querySelector('#modalAgregarCompProducto');
    
    if (btnSeleccionarCompProducto.length === 0 || !modalOrigen || !modalComposicionProducto) {
        return;
    }
    const contCompProductos = modalComposicionProducto.querySelector('#contReferencias');
    const inputFiltro = modalComposicionProducto.querySelector('#filtroReferencias');
    
    btnSeleccionarCompProducto.forEach(btn => {
        btn.addEventListener('click', function() {
            const inputOrigen = modalComposicionProducto.querySelector('#origenModal');
            if (inputOrigen) inputOrigen.value = this.getAttribute('data-origen') || '';
            const inputZona = modalComposicionProducto.querySelector('#zonaModal');
            if (inputZona) inputZona.value = this.getAttribute('data-zona') || '';
            cargarReferencias();
            modalComposicionProducto.classList.add('modal--show');
        });
    });


    //Filtro de búsqueda
    if (inputFiltro) {
        inputFiltro.addEventListener('input', function() {
            const termino = this.value.trim().toLowerCase();
            const items = contCompProductos.querySelectorAll('.referencia');
            items.forEach(item => {
                const codigo = (item.getAttribute('data-codigo') || '').toLowerCase();
                const ref    = (item.getAttribute('data-ref') || '').toLowerCase();
                const tipo    = (item.getAttribute('data-tipo') || '').toLowerCase();
                item.style.display = (!termino || tipo.includes(termino) || codigo.includes(termino) || ref.includes(termino)) ? '' : 'none';
            });
        });
    }

    async function cargarReferencias() {
        contCompProductos.innerHTML = '<p class="cargandoReferencias">Cargando referencias...</p>';
        try {
            const respuesta = await fetch('/api/configuracion/materia-prima/listar');
            const json      = await respuesta.json();
            if (respuesta.status !== 200 || !json.result) {
                contCompProductos.innerHTML = '<p class="no-info">No se pudieron cargar las referencias.</p>';
                return;
            }
            const referencias = json.result;

            if (!referencias.length) {
                contCompProductos.innerHTML = '<p class="no-info">No hay referencias disponibles.</p>';
                return;
            }
            
            contCompProductos.innerHTML = referencias.map(ref => `

                <div class="referencia" data-id="${ref.idMateriaPrima}" data-codigo="${ref.codigoMateriaPrima}" data-ref="${ref.descripcionMateriaPrima}" data-prov="${ref.proveedorMateriaPrima}">
                    <article class="articuloCard" >
                        <div class="articuloCardTitulo">
                            <h3>PET</h3>
                        </div>
                        <dl class="articuloCardLista">
                            <dt>Codigo:</dt>
                            <dd>${ref.codigoMateriaPrima}</dd>
                            <dt>Referencia:</dt>
                            <dd>${ref.descripcionMateriaPrima}</dd>
                            <dt>Proveedor:</dt>
                            <dd>${ref.proveedorMateriaPrima}</dd>
                        </dl>
                    </article>
                </div>
            `).join('');

            referenciasCargadas = true;

        } catch (error) {
            console.error('Error al cargar referencias:', error);
            contCompProductos.innerHTML = '<p class="no-info">Error al cargar las referencias.</p>';
        }
    }

    // Delegación de clics sobre las referencias renderizadas dinámicamente
    contCompProductos.addEventListener('click', function(e) {
        const item = e.target.closest('.referencia');
        if (!item) return;
        seleccionarReferencia(item);
    });

    function seleccionarReferencia(elemento) {
        const id        = elemento.getAttribute('data-id');
        const codigo    = elemento.getAttribute('data-codigo');
        const referencia = elemento.getAttribute('data-ref');
        const proveedor = elemento.getAttribute('data-prov');

        const zonaOrigen = modalComposicionProducto.querySelector('#zonaModal').value;
        if (!zonaOrigen) return;

        if (!zonaOrigen || !modalOrigen || !id || !codigo || !referencia || !proveedor) {
            alert('Faltan datos para completar la acción');
            window.location.reload();
            return;
        }

        const inputIdReferencia   = modalOrigen.querySelector(`#${zonaOrigen} .idMtPrima`);
        const inputCodReferencia  = modalOrigen.querySelector(`#${zonaOrigen} .codMtPrima`);
        const inputDescReferencia = modalOrigen.querySelector(`#${zonaOrigen} .refMtPrima`);
        const inputProvReferencia = modalOrigen.querySelector(`#${zonaOrigen} .provMtPrima`);

        if (!inputIdReferencia || !inputCodReferencia || !inputDescReferencia || !inputProvReferencia) {
            alert('No se encontraron los inputs destino');
            return;
        }

        inputIdReferencia.value   = id;
        inputCodReferencia.value  = codigo;
        inputDescReferencia.value = referencia;
        inputProvReferencia.value = proveedor;

        inputIdReferencia.setAttribute('readonly', true);
        inputCodReferencia.setAttribute('readonly', true);
        inputDescReferencia.setAttribute('readonly', true);
        inputProvReferencia.setAttribute('readonly', true);

        const inputCiclo = modalOrigen.querySelector('#ciclo');
        if (inputCiclo) inputCiclo.focus();

        modalComposicionProducto.classList.remove('modal--show');
    }

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function escapeAttr(str) {
        return String(str).replace(/"/g, '&quot;');
    }
});
